import { render } from "./star.html?vue&type=template&id=be471d04&scoped=true&ts=true"
import script from "./star.ts?vue&type=script&lang=ts"
export * from "./star.ts?vue&type=script&lang=ts"

import "./star.scss?vue&type=style&index=0&id=be471d04&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be471d04"]])

export default __exports__